import React, { Component } from 'react';
import Drawer from 'rc-drawer';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { connect } from 'react-redux'
import { Button } from 'reactstrap';
import SurveyGroupList from 'components/Agile/SurveyGroup/SurveyGroupList';
import AppModuleHeader from 'components/AppModuleHeader/index';
import AddSurveyGroup from 'components/Agile/SurveyGroup/AddSurveyGroup';
import IntlMessages from 'util/IntlMessages';
import CircularProgress from 'components/CircularProgress';
import CustomScrollbars from 'util/CustomScrollbars';

import {
    addFavouriteSurveyGroup,
    fetchSurveyGroups,
    filterSurveyGroup,
    getAllSurveyGroup,
    getUnselectedAllSurveyGroup,
    handleSurveyGroupRequestClose,
    hideSurveyGroupLoader,
    showSurveyGroupLoader,
    onAddSurveyGroup,
    onAllSurveyGroupSelect,
    onSurveyGroupClose,
    onSurveyGroupSelect,
    onDeleteSurveyGroup,
    onDeleteSelectedSurveyGroup,
    onFilterSurveyGroupOptionSelect,
    onSaveSurveyGroup,
    onToggleSurveyGroupDrawer,
    updateSearchSurveyGroup,
    onSurveyGroupQuestions
} from 'actions/SurveyGroup';


const filterOptions = [
    {
        id: 1,
        name: 'All Survey Groups',
        icon: 'zmdi-menu'
    }, {
        id: 2,
        name: 'Frequently Accessed',
        icon: 'zmdi-time-restore'

    }, {

        id: 3,
        name: 'Starred Survey Groups',
        icon: 'zmdi-star'
    }
];

class SurveyGroup extends Component {

    surveyGroupSideBar = () => {
        return <div className="module-side">
            <div className="module-side-header">
                <div className="module-logo">
                    <i className="zmdi zmdi-city-alt mr-4" />
                    <span><IntlMessages id="sidebar.surveyGroup" /></span>
                </div>
            </div>


            <div className="module-side-content">
                <CustomScrollbars className="module-side-scroll scrollbar"
                    style={{ height: this.props.width >= 1200 ? 'calc(100vh - 200px)' : 'calc(100vh - 80px)' }}>
                    <div className="module-add-task">
                        <Button className="btn-block jr-btn" color="primary"
                            onClick={this.onAddSurveyGroup}>
                            <i className="zmdi zmdi-accounts-add zmdi-hc-fw" />
                            <span>Add New SurveyGroup</span>
                        </Button>
                    </div>
                    <div className="module-side-nav">
                        <ul className="module-nav">
                            {filterOptions.map(option => <li key={option.id} className="nav-item">
                                <a href="javascript:void(0)"
                                    className={option.id === this.props.selectedSectionId ? 'active' : ''} onClick={
                                        this.onFilterSurveyGroupOptionSelect.bind(this, option)
                                    }>
                                    <i className={`zmdi ${option.icon}`} />
                                    <span>{option.name}</span>
                                </a>
                            </li>
                            )}

                        </ul>
                    </div>
                </CustomScrollbars>
            </div>
        </div>

    };

    addFavouriteSurveyGroup = (data) => {
        this.props.addFavouriteSurveyGroup(data);
    };
    onSurveyGroupSelect = (data) => {
        this.props.onSurveyGroupSelect(data);
    };
    onSurveyGroupQuestions = (data) => {
        this.props.onSurveyGroupQuestions(data);
    }
    onAddSurveyGroup = () => {
        this.props.onAddSurveyGroup();
    };
    onSurveyGroupClose = () => {
        this.props.onSurveyGroupClose();
    };
    onFilterSurveyGroupOptionSelect = (option) => {
        this.props.onFilterSurveyGroupOptionSelect(option);
    };
    onSaveSurveyGroup = (data) => {
        this.props.onSaveSurveyGroup(data);
    };
    onDeleteSurveyGroup = (data) => {
        this.props.onDeleteSurveyGroup(data);
    };
    onDeleteSelectedSurveyGroup = () => {
        this.props.onDeleteSelectedSurveyGroup();
    };
    filterSurveyGroup = (surveyGroupName) => {
        if (surveyGroupName === '') {
            this.onFilterSurveyGroupOptionSelect(this.props.filterOption);
        } else {
            this.props.filterSurveyGroup(surveyGroupName);
        }
    };
    handleSurveyGroupRequestClose = () => {
        this.props.handleSurveyGroupRequestClose();
    };
    getAllSurveyGroup = () => {
        this.props.getAllSurveyGroup();
    };
    getUnselectedAllSurveyGroup = () => {
        this.props.getUnselectedAllSurveyGroup();
    };
    onAllSurveyGroupSelect = () => {
        const selectAll = this.props.selectedSurveyGroups < this.props.surveyGroupList.length;
        if (selectAll) {
            this.props.getAllSurveyGroup();
        } else {
            this.props.getUnselectedAllSurveyGroup();
        }
    };
    onToggleSurveyGroupDrawer = () => {
        this.props.onToggleSurveyGroupDrawer();
    };
    showSurveyGroupLoader = () => {
        this.props.showSurveyGroupLoader();
    }

    constructor() {
        super();
    }

    componentDidMount() {
        this.props.showSurveyGroupLoader();
        this.props.fetchSurveyGroups();
    }


    updateSearchSurveyGroup(evt) {
        this.props.updateSearchSurveyGroup(evt.target.value);
        this.props.filterSurveyGroup(evt.target.value);
    }

    render() {
        const { surveyGroup, surveyGroupList, addSurveyGroupState, selectedSurveyGroups, alertMessage, showMessage, drawerState, noContentFoundMessage, loader } = this.props;
        return (
            <div className="app-wrapper">
                <div className="app-module animated slideInUpTiny animation-duration-3">

                    <div className="d-block d-xl-none">
                        <Drawer
                            touch={true}
                            transitions={true}
                            enableDragHandle={true}
                            open={drawerState}
                            onOpenChange={this.onToggleSurveyGroupDrawer.bind(this)}
                            sidebar={this.surveyGroupSideBar(surveyGroup)} />
                    </div>
                    <div className="app-module-sidenav d-none d-xl-flex">
                        {this.surveyGroupSideBar(surveyGroup)}
                    </div>

                    <div className="module-box">
                        <div className="module-box-header">
                            <span className="icon-btn drawer-btn d-flex d-xl-none"
                                onClick={this.onToggleSurveyGroupDrawer.bind(this)}>
                                <i className="zmdi zmdi-menu" />
                            </span>
                            <AppModuleHeader placeholder="Search Survey Group" notification={false} apps={false}
                                user={this.props.surveyGroup}
                                onChange={this.updateSearchSurveyGroup.bind(this)}
                                value={this.props.searchSurveyGroup} />
                        </div>
                        <div className="module-box-content">

                            <div className="module-box-topbar align-items-center">
                                <div className="form-control-checkbox d-flex">
                                    <div className="form-checkbox">
                                        <input type="checkbox"
                                            checked={selectedSurveyGroups > 0}
                                            onChange={this.onAllSurveyGroupSelect.bind(this)} />
                                        <span className="check">
                                            <i className="zmdi zmdi-check zmdi-hc-lg" />
                                        </span>
                                    </div>
                                </div>


                                {selectedSurveyGroups > 0 &&
                                    <span className="icon-btn"
                                        onClick={this.onDeleteSelectedSurveyGroup.bind(this)}>
                                        <i className="zmdi zmdi-delete" />
                                    </span>}

                            </div>
                            <CustomScrollbars className="module-list-scroll scrollbar"
                                style={{ height: this.props.width >= 1200 ? 'calc(100vh - 265px)' : 'calc(100vh - 245px)' }}>
                                {loader ?
                                    <div
                                        className="loader-view-block h-100">
                                        <div className="loader-view">
                                            <CircularProgress />
                                        </div>
                                    </div>
                                    :
                                    surveyGroupList && surveyGroupList.length > 0 ?
                                        <SurveyGroupList data={surveyGroupList}
                                            addFavouriteSurveyGroup={this.addFavouriteSurveyGroup.bind(this)}
                                            onSurveyGroupSelect={this.onSurveyGroupSelect.bind(this)}
                                            onDeleteSurveyGroup={this.onDeleteSurveyGroup.bind(this)}
                                            onSaveSurveyGroup={this.onSaveSurveyGroup.bind(this)}
                                            showSurveyGroupLoader={this.showSurveyGroupLoader.bind(this)}
                                            onSurveyGroupQuestions={this.onSurveyGroupQuestions.bind(this)} />
                                        :
                                        <div className="h-100 d-flex align-items-center justify-content-center">
                                            {noContentFoundMessage}
                                        </div>
                                }
                            </CustomScrollbars>

                        </div>
                    </div>
                </div>
                <AddSurveyGroup
                    open={addSurveyGroupState}
                    surveyGroup={{
                        'name': '',
                        'selected': false,
                        'starred': false,
                        'frequently': false,
                    }}
                    onSaveSurveyGroup={this.onSaveSurveyGroup}
                    onSurveyGroupClose={this.onSurveyGroupClose}
                    onDeleteSurveyGroup={this.onDeleteSurveyGroup}
                    showSurveyGroupLoader={this.showSurveyGroupLoader}
                />

                {showMessage && NotificationManager.success(alertMessage, this.handleSurveyGroupRequestClose())}
                <NotificationContainer />

            </div>
        );
    }
}


export const mapStateToProps = ({ surveyGroups, settings }) => {
    const { width } = settings;
    const {
        loader,
        alertMessage,
        showMessage,
        noContentFoundMessage,
        selectedSectionId,
        drawerState,
        surveyGroup,
        searchSurveyGroup,
        filterOption,
        allSurveyGroup,
        surveyGroupList,
        selectedSurveyGroup,
        selectedSurveyGroups,
        addSurveyGroupState
    } = surveyGroups;
    return {
        width,
        loader,
        alertMessage,
        showMessage,
        noContentFoundMessage,
        selectedSectionId,
        drawerState,
        surveyGroup,
        searchSurveyGroup,
        filterOption,
        allSurveyGroup,
        surveyGroupList,
        selectedSurveyGroup,
        selectedSurveyGroups,
        addSurveyGroupState
    };
};
export default connect(mapStateToProps, {
    fetchSurveyGroups,
    addFavouriteSurveyGroup,
    onSurveyGroupSelect,
    onAddSurveyGroup,
    onSurveyGroupClose,
    onFilterSurveyGroupOptionSelect,
    onSaveSurveyGroup,
    onDeleteSurveyGroup,
    onDeleteSelectedSurveyGroup,
    filterSurveyGroup,
    getAllSurveyGroup,
    getUnselectedAllSurveyGroup,
    onAllSurveyGroupSelect,
    updateSearchSurveyGroup,
    onToggleSurveyGroupDrawer,
    handleSurveyGroupRequestClose,
    hideSurveyGroupLoader,
    showSurveyGroupLoader,
    onSurveyGroupQuestions
})(SurveyGroup);


// WEBPACK FOOTER //
// ./components/Agile/SurveyGroup/index.js